import React,{ Component } from "react";
import { connect } from "react-redux";
import { getImages, deleteImages,setImagesPageInfo } from "../../actions/actionImage";
import { Link } from "react-router-dom";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import DataTable from "../../components/Table/Table"
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Images",path:"/images",isActive: true}
];

class Images extends Component{
    constructor(props){
        super(props);

        this.state = {
            modal: false,
            pages: 1,
            imageId: null,
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteImageAction = this.deleteImageAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    componentDidMount() {
        this.props.getImages();
    }

    deleteConfirm(imageId){
        this.setState({modal: !this.state.modal,
            imageId: imageId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteImageAction(){
        this.props.deleteImages(this.state.imageId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }	

    handleDeleteSuccess(){
        const {deleteImageErrorMessage} = this.props;
        if(deleteImageErrorMessage) {
            NotificationManager.error(deleteImageErrorMessage,"Delete Image Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Image","Delete Image", 3000);
            this.setState({modal: false});
            this.props.getImages();
        }
    }

    handleDeleteError(){
        const {deleteImageError} = this.props;
        if(deleteImageError){
            NotificationManager.error(deleteImageError,"Failed to Delete Image", 3000);
            this.props.history.push("/images");
        }else{
            NotificationManager.error("Failed to Delete Image","Delete Image", 3000);
            this.props.history.push("/images");
        }
    }

    render(){
        if (this.props.getImagesLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const { images } = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "Name",
                accessor: "friendly_name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Docker Image",
                accessor: "name",
                filterable: true,
                sortable: true
            },
            {
                type: "flag",
                name: "Enabled",
                accessor: "enabled",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Description",
                accessor: "description",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "clone", icon: "fa-clone", description: "Clone" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewimage/${item.image_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updateimage/${item.image_id}`);
                break;

                case "clone":
                    this.props.history.push(`/cloneimage/${item.image_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.image_id);
                break;
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/> 
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-image"></i> <strong>Images</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createimage" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                   Add Image
                                    </button>
                                </Link> 
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="images"
                                    data={images}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this Image?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} 
                        className="cancel-button"
                        size="sm" color=" basic"> Close</Button>
                        <Button onClick={this.deleteImageAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Images.propTypes = {
    getImages: Proptypes.func.isRequired,
    deleteImages: Proptypes.func.isRequired,
    deleteImageErrorMessage: Proptypes.func,
    deleteImageError: Proptypes.func,
    history: Proptypes.object.isRequired,
    images: Proptypes.array,
    createImagesLoading: Proptypes.bool,
    className: Proptypes.func
};


export default connect(state => ({
    images: state.images.images || [],
    getImagesLoading: state.images.getImagesLoading || false,
    createImagesLoading: state.images.createImagesLoading || false,
    deleteImageErrorMessage: state.images.deleteImageErrorMessage || null,
    deleteImageLoading: state.images.deleteImageLoading || false,
    deleteImageError: state.images.deleteImageError || null,
    pages : {pageSize : state.images.pageSize, pageNo : state.images.pageNo},

}), 
dispatch => ({
    getImages: () => dispatch(getImages()),
    deleteImages: (data) => dispatch(deleteImages(data)),
    setPageInfo : (data)=> dispatch(setImagesPageInfo(data)),
}))(Images);


// WEBPACK FOOTER //
// ./src/views/Images/Images.js